import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCarmf = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>        {context.state['Carriere'+ClientConjoint].filter((Carriere) => Carriere.Nature === "Carmf" ).length > 0 && (
        <div className="card">
          <div className="category-column">
            CARMF
          </div>
          <div className="value-column">
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompCarmf}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"RetraiteCompCarmf",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCarmfComp}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCarmfComp",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={resultRetraite?.InfosRetraite?.Carmf?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Carmf?.General?.PointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
        </div>
      )}
    </>
  );
};
export default PointCarmf;
